export const updateAllTaggableUsers = (value) => {
  return {
    type: "UPDATE_ALL_TAGGABLE_USERS",
    payload: {
      allTaggableUsers: value,
    },
  };
};
